import { T_AppliedFilter } from '../state/filtersStore'
import { I_SystemPost } from '../state/wpDataStore'

export const systemMatchesAllFilters = (
  system: I_SystemPost,
  filters: T_AppliedFilter[]
) => {
  // Only check against the filters that apply to system
  const systemFilters = filters.filter((f) => f.applies_to === 'systems')
  if (!systemFilters.length) return true

  const acf = system.acf ?? {}

  return systemFilters.every(({ acf_name, value }) => {
    let systemValue = undefined

    if (
      acf[acf_name] &&
      typeof acf[acf_name] === 'object' &&
      'value_new' in acf[acf_name]
    ) {
      systemValue = acf[acf_name].value_new
    } else {
      systemValue = 'bypass'
    }

    if (systemValue === 'bypass') return true

    const normalizedSystemValue =
      systemValue === 'yes' ? true : systemValue === 'no' ? false : systemValue
    const normalizedFilterValue =
      value === 'yes' ? true : value === 'no' ? false : value

    if (normalizedSystemValue === undefined) return false
    return String(normalizedSystemValue) === String(normalizedFilterValue)
  })
}
